export default __webpack_public_path__ + "static/empowering-edtech-platform-SIS-solution-53af92a813464a4547d15e2a00cc6718.jpg";